import moment from 'moment';

const Footer = () => {
	return (
		<footer className='mt-8'>
			<p className='text-center text-xs text-neutral-foreground-30 md:text-sm'>© {moment().format('YYYY')} UFood Official. All rights reserved.</p>
		</footer>
	);
};

export default Footer;
